import { HelperResult, ProfileCompletion } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetProfileCompletionParams {
  userId: number;
}

const { useGet: useGetProfileCompletion } = getCRUDHooks({
  entityName: 'profileCompletion',
  dependentEntities: [
    'trainingActivities',
    'about',
    'userDeclaredSkills',
    'JobPreference',
    'userJobSearchAreas',
    'UserCommunicationSettings',
    'phoneNumber',
    'professionalExperiences',
    'resumeFile',
    'socialLinks',
    'languageProficiency',
  ],
  get({ userId }: GetProfileCompletionParams): HelperResult<ProfileCompletion> {
    return clientApi.getOCClient().helpers.user.users.id(userId).profileCompletion.find();
  },
});

// eslint-disable-next-line import/prefer-default-export
export { useGetProfileCompletion };
